export const APP_NAME = import.meta.env.VITE_APP_NAME || 'INO Customer Portal';
/** major.minor.build.patch — shown in app sidebar and public pages footer */
export const APP_DISPLAY_VERSION = import.meta.env.VITE_APP_DISPLAY_VERSION || '0.0.0.0';
export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:8000/api';

export const ROUTES = {
  HOME: '/',
  LOGIN: '/login',
  PUBLIC_CN01_FORM: '/public/cn01-form',
  PUBLIC_SUPPLIER_FORM: '/public/supplier-form',
  DASHBOARD: '/app/dashboard',
  SETTINGS: '/app/settings',
  CN02_MANAGE: '/app/cn02-manage',
  CN02_CERTIFICATE: '/app/cn02-certificate',
  CN01_MANAGE: '/app/cn01-manage',
  CN01_DETAIL: '/app/cn01-detail',
  CN01_VIEW: '/app/cn01-view',
  CN03_MANAGE: '/app/cn03-manage',
  CN03_MANAGE_RG: '/app/cn03-manage/rg',
  CN03_FORM: '/app/cn03-form',
  CN03_OFFLINE: '/app/cn03-offline',
  CN04_MANAGE: '/app/cn04-manage',
  CN04_FORM: '/app/cn04-form',
  CN04_OFFLINE: '/app/cn04-offline',
  CN05_MANAGE: '/app/cn05-manage',
  CN05_FORM: '/app/cn05-form',
  CN05_OFFLINE: '/app/cn05-offline',
  CN06_MANAGE: '/app/cn06-manage',
  CN06_FORM: '/app/cn06-form',
  CN06_OFFLINE: '/app/cn06-offline',
  USERS_MANAGE: '/app/users-manage',
  USERS_CREATE: '/app/users/create',
  USERS_EDIT: '/app/users/edit',
  ROLES_MANAGE: '/app/roles-manage',
  ROLES_CREATE: '/app/roles/create',
  ROLES_EDIT: '/app/roles/edit',
  REPORTS: '/app/reports',
  SUPPLIERS_MANAGE: '/app/suppliers-manage',
  SUPPLIERS_FORM: '/app/suppliers',
  PEST_DISEASE_MANAGE: '/app/pest-disease-manage',
  PEST_DISEASE: '/app/pest-disease',
  FINANCIAL_MANAGE: '/app/financial-manage',
  FINANCIAL_CREATE: '/app/financial/create',
  FINANCIAL_EDIT: '/app/financial/edit',
  FINANCIAL_VIEW: '/app/financial/view',
  FINANCIAL_CALCULATE: '/app/financial/calculate',
  FINANCIAL_ESTIMATE: '/app/financial-estimate',
} as const;

export const STORAGE_KEYS = {
  TOKEN: 'token',
  REFRESH_TOKEN: 'refreshToken',
  USER: 'user',
} as const;
